<template>
  <div v-if="!showBannedAlert && !showUnderMaintenanceMode" id="login-page">
    <div class="wrapper fadeInDown">
      <div id="formContent">
        <!-- Icon -->
        <div class="fadeIn first circular--portrait">
          <img :src="logo" id="icon" alt="School Logo" />
        </div>
        <!-- <div style="padding: 0 40px; text-align: left;">
          <alert-message
            extra-small
            type="success"
            title="Password Reset Success !!"
            message="Please login with your newly created password."
          ></alert-message>
        </div> -->
          
        <!-- Login Form -->
        <form @submit.prevent="loginSystem ? commonLogin() :login()" @keydown="form.errors.clear($event.target.name)" v-if="!passwordResetStatus">
          <span class="error-message">{{ form.errors.message }} <br />
            <strong v-if="loginAttempts <= 3 && loginAttempts">You Have: {{ 3 - loginAttempts }} More Attempts
              Left</strong>
          </span>
          <div>
          <div class="mt-5" style="padding: 10px 40px; text-align: left;" v-if="passwordSuccessMsg">
            <alert-message
              extra-small
              type="success"
              title="Password Changed"
              :message="passwordSuccessMsg"
            ></alert-message>

          </div>
          </div>
          <div class="login-input">
            <input type="text" id="login" class="fadeIn second" :class="form.errors.has('username') ? 'red' : ''"
              autocomplete="off" name="username" v-model="form.username" placeholder="Username" />
          </div>
          <div class="login-input">
            <input :type="unlock === true ? 'text' : 'password'" id="password" class="fadeIn third"
              :class="form.errors.has('password') ? 'red' : ''" autocomplete="off" name="password"
              v-model="form.password" placeholder="Password" />
            <v-icon v-if="unlock === false" @click="unlock = true">lock</v-icon>
            <v-icon v-else @click="unlock = false">lock_open</v-icon>
          </div>
          <input :disabled="form.password.length < 8 ||
            form.username.length < 3 ||
            loginAttempts >= 3
            " id="login_submit_button" type="submit" class="fadeIn fourth" value="Log In" />
        </form>

        <form v-if="passwordResetStatus" @submit.prevent="sendPasswordResetCode"
          @keydown="passwordForgetForm.errors.clear($event.target.name)">
          <span class="error-message">{{ passwordForgetForm.errors.message }} <br />
            <strong v-if="loginAttempts <= 3 && loginAttempts">You Have: {{ 3 - loginAttempts }} More Attempts
              Left</strong>
          </span>

          <div class="mt-5" style="padding: 10px 40px; text-align: left;" v-if="form.errors.message">

            <alert-message
              extra-small
              type="error"
              title="Password Setup !!"
              :message="form.errors.message"
            ></alert-message>
          </div>

          
          <!-- <div class="login-input">
            <input
              type="text"
              id="username"
              class="fadeIn second"
              :class="passwordForgetForm.errors.has('username') ? 'red' : ''"
              autocomplete="off"
              name="username"
              v-model="passwordForgetForm.username"
              placeholder="Username"
            />
          </div> -->
          <div class="login-input">
            <input type="text" id="email" class="fadeIn second"
              :class="passwordForgetForm.errors.has('email') ? 'red' : ''" autocomplete="off" name="email"
              v-model="passwordForgetForm.email" placeholder="Phone Number or Email" />
            <p><small>We'll send you a One-Time Password (OTP) to help you change your password securely.</small></p>
          </div>
          <input :disabled="!passwordForgetForm.email && !passwordForgetForm.username
            " type="submit" class="fadeIn fourth" value="Send Sms" />
        </form>
        <!-- Remind Passowrd -->
        <div id="formFooter">
          <a class="underlineHover" v-if="!passwordResetStatus" @click="
            (passwordResetStatus = true),
            (passwordForgetForm.email = ''),
            (passwordForgetForm.username = '')
            ">Forgot Password?</a>

          <a class="underlineHover" v-if="passwordResetStatus" @click="
            (passwordResetStatus = false),
            (form.passsword = ''),
            (form.username = ''),
            (form.errors.message = '')
            ">Login</a>
        </div>
      </div>
    </div>
    <v-dialog @keydown.esc="roleSelectDialog = false" v-model="roleSelectDialog" persistent max-width="400"
      class="role-selecter">
      <!--<v-card>-->

      <v-list two-line>
        <template v-for="(role, index) in roles">
          <v-subheader v-if="index < 1" :key="index">Sign in as</v-subheader>
          <v-divider v-if="index > 0" :key="index" :inset="true"></v-divider>

          <v-list-item :id="'chooseRoleAction' + '-' + role.slug" :key="role.slug" avatar
            @click="requestPermissions(role)" v-if="role.slug !== 'sms-user' && role.slug !== 'sms-reseller'">
            <v-list-item-avatar>
              <img :src="getAvatar(role.name)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <strong style="color: #666">{{ role.name }}</strong>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span> <span class="text--primary">Last Logged In</span></span>
                &mdash;
                <span>{{ getLastLoggedIn(role.slug) }} </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-dialog>

    <v-dialog v-model="twoAuthDialog" persistent max-width="540" class="role-selecter">
      <v-card class="">

        <v-card-title class="primary white--text">
          <span class="title">Input your Verification code</span>
        </v-card-title>

         <div class="mt-5" style="padding: 0 40px; text-align: left;" v-if="form.errors.message">

          <alert-message
            extra-small
            type="error"
            title="Login verifciation code error!!"
            :message="form.errors.message"
          ></alert-message>
        </div>

        <div class="mt-5" style="padding: 0 40px; text-align: left;" v-if="changePasswordForm.errors.message">

          <alert-message
            extra-small
            type="error"
            title="Password Reset Error!!"
            :message="changePasswordForm.errors.message"
          ></alert-message>
        </div>

        <!-- <v-card-title class="text-h6">We have sent you 6 digit verification code</v-card-title> -->
        <v-card-text v-if="verificationCodeLoader">
          <!-- Loader  {{ verificationCodeLoader.toString() }} -->
          <Loader :showloader="verificationCodeLoader"></Loader>
        </v-card-text>
        <v-card-text>
          <br>
          <br>
          <div class="d-flex justify-space-between verification-code-input">
            <input v-model="code[index]"
              style="padding:0!important;width: 30px!important;height: 50px; width: 60px;font-weight: bold;" value="2"
              ref="codeInput" @input="onInput(index)" v-for="(digit, index) in code.length" :key="index" type="text" />
            <!-- <v-text-field
              maxlength="1"
              class="mx-1 text-center"
              outlined
              dense
              hide-details
              solo
              style="text-align: center;border: 1px solid #555;box-shadow: none;"
              @keydown.backspace="onBackspace(index)"
            /> -->
          </div>
          <br>
          <h3 v-if="resendCountdown === 0">
            Didn't get the verification code? Click
            <span v-if="resendCodeLoader"> <v-progress-circular indeterminate color="primary" size="20"
                width="2" /></span>
            <a v-else style="color: green; cursor: pointer;" @click="handleResend"><u>Resend</u> </a>
          </h3>
          <h3 v-else>
            Please wait {{ resendCountdown }} second<span v-if="resendCountdown > 1">s</span> to resend.
          </h3>

        </v-card-text>
        <br>
        <br>

        <!-- <v-card-actions>
          <v-spacer />
          <v-btn color="error" outlined @click="cancelTwoFactor()"
            >Cancel</v-btn
          >
         
        </v-card-actions> -->

      </v-card>

    </v-dialog>


    <v-dialog v-model="passwordResetDialog" persistent max-width="480" class="role-selecter">
       <v-card-title class="primary white--text">
          <span class="title">Reset Password</span>
        </v-card-title>

      <v-card class="pa-4">
        <span class="error-message" v-if="changePasswordForm.errors.password">
          {{ changePasswordForm.errors.password }}
        </span>
        <br>
        <span class="error-message" v-if="changePasswordForm.errors.confirm_password">
          {{ changePasswordForm.errors.confirm_password }}
        </span>

        <v-card-text>

          <div class="login-input" style="width: 100%;">
            <!-- :class="changePasswordForm.errors.password ? 'red' : ''" -->

            <input style="width:100%" :type="passwordUnlock === true ? 'text' : 'password'" id="password" class="fadeIn third"
              autocomplete="off" name="password" v-model="changePasswordForm.password" placeholder="Password" />
            <v-icon v-if="passwordUnlock === false" @click="passwordUnlock = true">lock</v-icon>
            <v-icon v-else @click="passwordUnlock = false">lock_open</v-icon>
          </div>
          <div class="login-input" style="width: 100%;">
            <!-- :class="changePasswordForm.errors.confirm_password ? 'red' : ''" -->

            <input style="width:100%" :type="confirmPasswordUnlock === true ? 'text' : 'password'" id="confirm_password"
              class="fadeIn third" autocomplete="off" name="confirm_password"
              v-model="changePasswordForm.confirm_password" placeholder="Confirm Password" />
            <v-icon v-if="confirmPasswordUnlock === false" @click="confirmPasswordUnlock = true">lock</v-icon>
            <v-icon v-else @click="confirmPasswordUnlock = false">lock_open</v-icon>
          </div>

          <div class="mt-5" style="font-size: 13px;">
            <ul>
              <li>Password must be atleast 8 characters long</li>
              <li>Should atleast have one numeric character (1234567890)</li>
              <li>Should have atleast one special character (*%&@! etc.)</li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <!-- <v-btn color="error" outlined @click="cancelPaaswordReset()">Cancel</v-btn> -->
          <h3 >
           Cancel Reset Password and go back to           
              <a style="color: green; cursor: pointer;" @click="cancelPaaswordReset(), cancelTwoFactor()"><u>Login?</u> </a>
          </h3>
          &nbsp;
          &nbsp;
          <v-btn color="success" 
            :disabled="resetPasswordLoader || (changePasswordForm.password !== changePasswordForm.confirm_password) || !changePasswordForm.password"
            outlined
            :loading="resetPasswordLoader"
            @click="resetPassword()">Reset</v-btn>

        </v-card-actions>

      </v-card>
    </v-dialog>


     <v-dialog @keydown.esc="displayCompanyDialog = false" v-model="displayCompanyDialog" persistent max-width="400"
      class="role-selecter">
      <!--<v-card>-->

      <v-list two-line>
        <template v-for="(company, index) in userCompanies">
          <v-subheader :key="index">select company</v-subheader>
         

          <v-list-item :id="'chooseRoleAction' + '-' + company.slug" :key="company.slug" avatar
            @click="setCompanyHeader(company)" >
            <v-list-item-avatar>
              <img :src="getAvatar(company.name)" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <strong style="color: #666">{{ company.name }}</strong>
              </v-list-item-title>
              <!-- <v-list-item-subtitle>
                <span> <span class="text--primary">Last Logged In</span></span>
                &mdash;
                <span>{{ getLastLoggedIn(company.slug) }} </span>
              </v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-dialog>
    <!-- <v-snackbar
      v-model="snackbarG"
      color="primary"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      Login is currently disabled. Please contact system administration.
      <v-btn color="white" text @click="snackbarG = false"> Close </v-btn>
    </v-snackbar> -->
  </div>
  <h1 v-else-if="showBannedAlert">
    <span style="padding: 50px">ALAS!!! Our Server is currently down. Please contact system administrator
      for more info.</span>
  </h1>
  <under-maintenance v-else-if="showUnderMaintenanceMode"></under-maintenance>
</template>
<script>

import Form from "@/library/Form";
import cookie from "js-cookie";
import { mapActions } from "vuex";
import {
  getPropertyFromArrayObject,
  showBannedAlert,
  showUnderMaintenanceMode,
  isSystemLogin
} from "../../../library/helpers";
import ls from "./../../../library/Storage";
import UnderMaintenance from "../../../components/UnderMaintenance";
import encryption from "@/library/Encryption";
import Loader from "../../../components/Loader"
import { format, formatDistance, formatRelative, subDays } from "date-fns";
export default {
  components: {
    UnderMaintenance,
    Loader
  },
  data: () => ({
    // eventBus: new Vue(), 
    requestingPermission: false,
    roleSelectDialog: false,
    twoAuthDialog: false,
    unlock: false,
    passwordUnlock: false,
    confirmPasswordUnlock: false,
    roleAvatar: [
      {
        name: "administrator",
        avatar:
          "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/administrator.png",
      },
      {
        name: "teacher",
        avatar:
          "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/teacher.png",
      },
      {
        name: "accountant",
        avatar:
          "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/accountant.png",
      },
      {
        name: "guardian",
        avatar:
          "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/guardian.png",
      },
      {
        name: "sms",
        avatar:
          "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/sms.png",
      },
    ],
    roles: [],
    form: new Form(
      {
        username: "",
        password: "",
        auth_code: "",
      },
      "/auth/login"
    ),
    passwordResetStatus: false,

    passwordForgetForm: new Form(
      {
        email: "",

      },
      "/password-reset"
    ),

    changePasswordForm: new Form({
      password: "",
      confirm_password: "",
    }),


    loginAttempts: null,
    logoFirst: "",

    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    code: Array(6).fill(""),
    enable_two_factor_auth: false,
    resendCountdown: 0,
    resendTimer: null,
    passwordResetDialog: false,
    resetMode: 'verification',

    resetPasswordLoader: false,
    resendCodeLoader: false,
    verificationCodeLoader: false,
    passwordSuccessMsg: '',
    userCompanies: [],
    displayCompanyDialog: false,
    loginSystem: ''
  }),
  mounted() {
    if ([null, undefined, ""].includes(cookie.get("_cl")) && !isSystemLogin()) {
      //API call
      this.fetchSchoolLogo();
    }
    
    // console.log(process.env.VUE_APP_LOGIN_SYSTEM, 'process.env.VUE_APP_LOGIN_SYSTEM')
    this.loginSystem = isSystemLogin();
    this.checkForTwoEnableAuth()
    this.restoreTimerIfActive();

  },
  computed: {
    logo() {
      return cookie.get("_cl")
        ? cookie.get("_cl")
        : this.logoFirst.length > 0
          ? this.logoFirst
          : "https://image.ibb.co/cVTEsG/eAcademy.png";
    },
    showBannedAlert,
    showUnderMaintenanceMode,
  },
  methods: {
    ...mapActions(["setUser", "setBatch"]),

    getProperty: getPropertyFromArrayObject,
    getLastLoggedIn(role) {
      if (role) {
        let lastLogged = ls.get(`_lg_in_${role.toString()}`);
        if (lastLogged) {
          lastLogged = formatRelative(new Date(lastLogged), new Date());
          return lastLogged[0].toUpperCase() + lastLogged.slice(1);
        } else {
          return "Not logged yet";
        }
      }
    },
    async fetchSchoolLogo() {
      await this.$rest.get("api/company-profile", {}, {
        headers: {
          Domain: "nibesh.dev"
        }
      }).then((data) => {
        cookie.set("_cl", data.data.logo);
        cookie.set("_two_factor_auth", data.data.enable_two_factor_auth)

        // this.enable_two_factor_auth = data.data.enable_two_factor_auth;
        this.logoFirst = data.data.logo;
      });
    },

    checkForTwoEnableAuth() {
      const twoFactorAuth = cookie.get('_two_factor_auth')
      if (twoFactorAuth === undefined) {
        this.fetchSchoolLogo();
      } else {
        this.enable_two_factor_auth = twoFactorAuth
      }
    },

    login() {
      // if(!this.$localStorage.getFromStorage('_selectedCompany')) {
      //   this.commonLogin();

      // }else {
      if (this.enable_two_factor_auth && this.code.every(c => c == "")) {
        this.sendAuthenticationCode()
        return;
      } else {
        this.handleOnlyLogin()

      }

      // }


    },
    handleOnlyLogin() {
       this.form.auth_code = this.code.join("");
        this.verificationCodeLoader = true;

        this.$rest
          .post(this.form.endpoint, this.form.data())
          .then(({ data }) => {
            this.twoAuthDialog = false;
            let currentBatch = null;
            this.cancelTwoFactor();
            let b = this.$storage.get("batch");
            if (b) {
              currentBatch = b;
            } else {
              currentBatch = encryption.decrypt(data.batch);
            }
            if (currentBatch) {
              currentBatch = JSON.parse(currentBatch);
              this.setBatch({
                id: currentBatch.id,
                start: currentBatch.batch_start || currentBatch.start,
                end: currentBatch.batch_end || currentBatch.end,
                name: currentBatch.name,
                is_hs: currentBatch.is_hs,
                is_current_batch: currentBatch.is_current_batch,
              });
            }
            this.$auth.set(data);
            this.setUser(this.$auth.user());
            this.roles = this.$auth.user().roles;
            if (this.roles.length === 1) {
              let role = this.roles[0];
              this.requestPermissions(role);
            } else if (this.roles.length > 1) {
              this.roleSelectDialog = true;
            }
          })
          .catch(({ response }) => {
            if (response) {
              if(response.data.code === 106) {
                this.passwordForgetForm.email = this.form.username
                this.passwordResetStatus = true;
              }
              if (response.data.total_attempts !== 0) {
                this.loginAttempts = response.data.total_attempts;
              }

              this.form.errors.message = response.data.message;
              this.$events.fire("notification", {
                message: response.data.message,
                status: "error",
              });
              this.code = Array(6).fill("");

              this.form.errors.record(
                response.data.message,
                response.data.errors
              );
            }
          }).finally(() => {
            this.verificationCodeLoader = false
          })
    },
    forgetPassword() { },
    getAvatar(roleName) {
      roleName = roleName.toLowerCase();
      let avatar =
        "https://eacademy.sgp1.digitaloceanspaces.com/eacademy/icons/others.png";
      this.roleAvatar.map(function (item) {
        if (item.name === roleName) {
          avatar = item.avatar;
        }
      });
      return avatar;
    },
    requestPermissions(role) {
      if (!role) return;
      // if (role.slug === "guardian") {
      //   this.snackbarG = true;
      // } else {
      this.$auth.setRole(role.slug);
      this.requestingPermission = true;
      this.$rest
        .get("/api/me/permissions?for=" + role.slug.toString())
        .then(({ data }) => {
          this.$auth.setPermission(data.permissions);
          this.fetchCommunicatorToken();
          const date = new Date();
          ls.set(`_lg_in_${role.slug.toString()}`, date);
          this.$router.replace({ name: "home" });
        })
        .catch((error) => {
          this.roleSelectDialog = false
          this.form.errors.record(
            error.response.data.message,
            error.response.data.error
          );
        })
        .finally(() => {
          this.requestingPermission = false;
        });
      // }
    },

    fetchCommunicatorToken() {
      this.$rest.get("/auth/communicator/token").then((res) => {
        if (res.data.communicate_token) {
          ls.set("_comm_tk", res.data.communicate_token);
        }
      });
    },

    onInput(index) {
      const input = this.code[index];
      if (input.length > 1) {
        this.code[index] = input.slice(-1); // Only keep last character
      }

      // Auto-move to next box
      if (this.code[index] && index < this.code.length - 1) {
        this.$nextTick(() => {
          this.$refs.codeInput[index + 1]?.focus();
        });
      }


      // If last box is filled, check if all boxes are filled
      if (index === this.code.length - 1 && this.code.every(c => c !== "")) {
        if (!this.passwordResetStatus) {
          this.login(); // Trigger the function
        } else {
          this.verifyPasswordResetCode()
        }
      }
    },
    onBackspace(index) {
      if (!this.code[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.codeInput[index - 1]?.focus();
        });
      }

    },
    // submitCode() {
    //   const authCode = this.code.join("");
    //   console.log(authCode, 'authcode')
    // },

    sendAuthenticationCode() {
      this.$events.listen("notification", () => {
         
        this.snackbar = {
          message:  "test",
          status:  "success",
          show: true,
        };
      });
      this.resendCodeLoader = true
      this.form.errors.message = ''
      this.$rest.post('/auth/send-auth-verification-code', this.form.data())
        .then((res) => {
          if(res.data.code === 206) return this.handleOnlyLogin()

          this.startResendTimer();
          this.twoAuthDialog = true
        }).catch((err) => {
          this.form.errors.message = err.response.data.message,

            this.$events.fire("notification", {
              message: err.response.data.message,
              status: "error",
            });

        })
    },

    startResendTimer(remainingTime = 60) {
      this.resendCodeLoader = false;
      const expiresAt = Date.now() + remainingTime * 1000;
      localStorage.setItem("resend_code_expiry", expiresAt.toString());

      this.updateCountdownFromStorage(); // immediately update UI

      this.resendTimer = setInterval(() => {
        this.updateCountdownFromStorage();
      }, 1000);
    },


    handleResend() {
      if (this.resendCountdown > 0) return;
      if (!this.passwordResetStatus) {
        this.sendAuthenticationCode(); // call the resend API

      } else {
        this.sendPasswordResetCode();
      }
      // this.startResendTimer();       // start countdown
    },

    updateCountdownFromStorage() {
      const expiresAt = parseInt(localStorage.getItem("resend_code_expiry") || "0");
      const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      this.resendCountdown = remaining;

      if (remaining === 0 && this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
        localStorage.removeItem("resend_code_expiry");
      }
    },

    restoreTimerIfActive() {
      const expiresAt = parseInt(localStorage.getItem("resend_code_expiry") || "0");
      if (expiresAt && Date.now() < expiresAt) {
        const remainingTime = Math.ceil((expiresAt - Date.now()) / 1000);
        this.startResendTimer(remainingTime); // use actual remaining time
        this.twoAuthDialog = true;
      }
    },
    cancelPaaswordReset() {
      this.passwordResetDialog = false
      this.passwordResetStatus = false
      this.changePasswordForm.passsword = ''
      this.changePasswordForm.confirm_password = ''
      this.changePasswordForm.errors = {}
      this.passwordForgetForm.email = ''
    },

    cancelTwoFactor() {
      this.twoAuthDialog = false;
      // this.passwordForgetForm.email = ''
      // Clear the resend countdown timer
      if (this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
      }

      // Reset countdown and remove localStorage entry
      this.resendCountdown = 0;
      localStorage.removeItem("resend_code_expiry");

      // Optionally, clear the entered code
      this.code = Array(6).fill("");
    },
    sendPasswordResetCode() {
      this.verificationCodeLoader = true;
      this.$rest.post('/auth/send-password-reset-code', this.passwordForgetForm.data())
        .then((res) => {
          this.startResendTimer();
          this.twoAuthDialog = true
        })
        .catch((err) => {
          this.code = Array(6).fill("");
          this.passwordForgetForm.errors.message = err.response.data.message;

          this.$nextTick(() => {
            if (this.$refs.codeInput && this.$refs.codeInput[0]) {
              this.$refs.codeInput[0].focus();
            }
          });

        }).finally(() => {
          this.verificationCodeLoader = false;
        })
    },

    verifyPasswordResetCode() {
      this.verificationCodeLoader = true
      const passwordResetCode = this.code.join("");
      this.$rest.post('/auth/verify-password-reset-code', { passwordResetCode: passwordResetCode, email: this.passwordForgetForm.email })
        .then((res) => {
          this.passwordResetDialog = true
          this.form.errors.message = '';
          this.cancelTwoFactor();
        })
        .catch((err) => {
          this.changePasswordForm.errors.message = err.response.data.message;
          this.code = Array(6).fill("");

          this.$nextTick(() => {
            if (this.$refs.codeInput && this.$refs.codeInput[0]) {
              this.$refs.codeInput[0].focus();
            }
          });


        }).finally(() => {
          this.verificationCodeLoader = false
        })
    },

    validatePasswordForm() {
      this.changePasswordForm.errors = {};

      const password = this.changePasswordForm.password;
      const confirmPassword = this.changePasswordForm.confirm_password;

      const regex = /^(?=.*[0-9])(?=.*[\W_]).{8,}$/;

      // Initialize error tracking
      let isValid = true;

      if (!password) {
        this.changePasswordForm.errors.password = 'Password is required.';
        isValid = false;
      } else if (!regex.test(password)) {
        this.changePasswordForm.errors.password =
          'Password must be at least 8 characters long, include at least one number and one special character.';
        isValid = false;
      }

      if (!confirmPassword) {
        this.changePasswordForm.errors.confirm_password = 'Confirm password is required.';
        isValid = false;
      } else if (password !== confirmPassword) {
        this.changePasswordForm.errors.confirm_password = 'Passwords do not match.';
        isValid = false;
      }

      return isValid;
    },

    resetPassword() {
      if (this.validatePasswordForm()) {
        this.resetPasswordLoader = true
        this.$rest.post('/auth/change-password', { password: this.changePasswordForm.password, confirm_password: this.changePasswordForm.confirm_password, email: this.passwordForgetForm.email })
          .then((res) => {
            this.cancelPaaswordReset();
            this.cancelTwoFactor()
            this.passwordResetStatus = false
            this.passwordSuccessMsg = res.data.message
          }).catch((err) => {
          }).finally(() => {
            this.resetPasswordLoader = false
            setTimeout(() => {
              this.passwordSuccessMsg = ''
            }, 5000);
          })

      }
    },
    commonLogin(){
     
      this.$rest.post('/auth/common-login', {username: this.form.username, password: this.form.password})
      .then(({data}) => {
        if (Array.isArray(data) && data.length > 1) {
            this.displayCompanyDialog = true;
            this.userCompanies = data;
          } else if (Array.isArray(data) && data.length === 1) {
            this.setCompanyHeader(data[0]);
          } else {
            this.form.errors.message = "No company found.";
        }
      }).catch(({response}) => {
          this.form.errors.message = response.data.message;
        
      })
    },
    setCompanyHeader(company) {
      this.$localStorage.removeFromStorage('_selectedCompany')
      this.$localStorage.setToStorage('_selectedCompany', company);
      this.displayCompanyDialog = false
      this.login()
    }



  },
};
</script>
<style lang="scss" scoped>
.verification-code-input {
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none;
  }

  .v-text-field--outlined fieldset {
    border: none;
  }
}

#login-page {
  height: 100%;
  min-height: 100vh;
  width: 100%;
  background: #9053c7;
  background: -webkit-linear-gradient(-135deg, #c850c0, #4158d0);
  background: -o-linear-gradient(-135deg, #c850c0, #4158d0);
  background: -moz-linear-gradient(-135deg, #c850c0, #4158d0);
  background: linear-gradient(-135deg, #c850c0, #4158d0);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #39ace7;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"],
input[type="password"] {
  background-color: #f6f6f6;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 95%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

input.red {
  color: red;

  &:focus {
    border-bottom: 2px solid red;
  }
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 200px;
  margin-top: 25px;
}

* {
  box-sizing: border-box;
}

input[type="submit"]:disabled {
  cursor: not-allowed;
  background-color: #ccc;
  box-shadow: none;
}

.error-message {
  color: #ef4545;
  padding: 0 15px;
}

.login-input {
  width: 85%;
  margin: auto;
  position: relative;

  .material-icons {
    position: absolute;
    right: 22px;
    top: 22px;
    cursor: pointer;
  }
}

.text-center input {
  text-align: center;
  font-size: 20px;
}
</style>
